<template>
    <div v-if="false"></div>
</template>
<script>
export default {
  props: {
    item: {
      required: true
    },
    componentType: {
      required: true
    },
    relationIdentifier: {
      required: true
    }
  },
  setup (props) {
    return {
    }
  }
}
</script>
